<template>
  <el-dialog
    class="store-dialog"
    title="变更销售组织"
    :visible.sync="showDialog"
    :close-on-click-modal="false"
    :before-close="cancelAction"
    append-to-body
    width="1100px"
  >
    <div v-if="showDialog">
      <el-tabs
        v-if="showStore && showGroup"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          label="销售店铺"
          name="store"
        />
        <el-tab-pane
          label="销售群组"
          name="group"
        />
      </el-tabs>
      <div>
        <Store
          v-if="activeName === 'store' && showStore"
          :show-store="showStore"
          :choose-only-store="chooseOnlyStore"
          :selected-store-ids="selectedStoreIds"
          :is-show-select-group="isShowSelectGroup"
          @chooseStore="saveBindOrganization"
        />
        <Group
          v-if="activeName === 'group' && showGroup"
          :show-group="showGroup"
          :selected-groups-ids="selectedGroupsIds"
          @chooseGroups="saveBindOrganization"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Group from './group.vue'
import Store from './store.vue'
export default {
  name: 'SpSalesOrganization',
  components: {
    Group,
    Store
  },
  model: {
    prop: 'showDialog',
    event: 'showDialogChange'
  },
  props: {
    showDialog: {
      // 展示选择门店的模态框
      type: Boolean,
      default: false
    },
    selectData: {
      // 包含selectedStoreIds店铺id值，selectedGroupsIds群组id值
      type: Object,
      default: () => {
        return {
          selectedStoreIds: [],
          selectedGroupsIds: []
        }
      }
    },
    showStore: {
      type: Boolean,
      default: true
    },
    showGroup: {
      type: Boolean,
      default: true
    },
    chooseOnlyStore: {
      type: Boolean,
      default: false
    },
    isShowSelectGroup: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      tableList: [],
      total_count: 0,
      params: {
        group_code: '',
        group_name: ''
      },
      activeName: 'store',
      selectedStoreIds: null,
      selectedGroupsIds: null
    }
  },
  watch: {
    showDialog (newVal, oldVal) {
      if (newVal) {
        this.selectedStoreIds = this.selectData.selectedStoreIds || []
        this.selectedGroupsIds = this.selectData.selectedGroupsIds || []

        if (!this.showStore && this.showGroup) {
          this.activeName = 'group'
        } else {
          this.activeName = 'store'
        }
      }
    }
  },
  methods: {
    // 关闭模态框
    cancelAction () {
      this.$emit('showDialogChange', false)
    },

    // 保存
    saveBindOrganization (data) {
      this.$emit('saveBindOrganization', data, this.activeName)
    },

    handleClick (tab, event) {
      if (tab.name === 'store') {
        this.showStore = true
      } else {
        this.showGroup = true
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
